'use strict';


export default function($timeout) {
	'ngInject';

	return {
		restrict: 'A',
		link: postLink,
	}

	function postLink(scope, element, attrs) {
		$timeout(function() {
			element[0].focus();
		});
	}
}
